import { useState } from "react";
import { api } from "../api";
import { Gauge } from "../components/Strata";
import { Notice, Section, Spinner, msgs, ruDate, useAsync } from "../components/common";
import { openChannel } from "../telegram";

type Filter = "all" | "thread" | "post";

const LABELS: Record<Filter, string> = {
  all: "Всё",
  thread: "Обсуждения",
  post: "Каналы",
};

export function FeedTab({ onOpenThread }: { onOpenThread: (id: number) => void }) {
  const [filter, setFilter] = useState<Filter>("all");
  const { data, loading, error } = useAsync(
    () => api.feed({ limit: 40, kind: filter === "all" ? undefined : filter }),
    [filter]
  );

  return (
    <>
      <div className="screen-head">
        <div className="rail">2018 — 2026</div>
        <h1>Лента</h1>
        <p>Обсуждения, поднятые из архива, и свежее из каналов сообщества</p>
      </div>

      <div className="chips">
        {(Object.keys(LABELS) as Filter[]).map((f) => (
          <button key={f} className="chip" aria-pressed={filter === f} onClick={() => setFilter(f)}>
            {LABELS[f]}
          </button>
        ))}
      </div>

      {loading && <Spinner />}
      {error && <Notice>{error}</Notice>}
      {data && data.length === 0 && (
        <Notice>
          {filter === "post"
            ? "Посты каналов ещё не загружены — не запускался этап Telethon."
            : "Пока пусто."}
        </Notice>
      )}

      {data && data.length > 0 && (
        <Section>
          {data.map((item) => (
            <button
              key={`${item.kind}-${item.id}`}
              className="row"
              onClick={() =>
                item.kind === "thread"
                  ? onOpenThread(item.id)
                  : item.channel_handle && openChannel(item.channel_handle)
              }
            >
              <div className="row-title">{item.title ?? "Без названия"}</div>
              {item.summary && item.summary !== item.title && (
                <div className="row-sub">{item.summary}</div>
              )}
              {/* Separators are dropped here: with a date, two counts, a gauge
                  and a reaction tally, the slashes were what pushed the line
                  onto a second row. The gap carries the grouping instead. */}
              <div className="row-meta row-meta--tight">
                <span>{ruDate(item.ts)}</span>
                {item.kind === "thread" ? (
                  <>
                    <span>{msgs(item.msg_count)}</span>
                    <span>{item.participant_count} уч.</span>
                    {item.reaction_total > 0 && <span>{item.reaction_total} ♥</span>}
                    <Gauge
                      value={item.quality ?? 2}
                      label={`содержательность ${item.quality} из 5`}
                    />
                  </>
                ) : (
                  <>
                    <span className="badge">@{item.channel_handle ?? "канал"}</span>
                    {item.author && <span>{item.author}</span>}
                    {item.reaction_total > 0 && <span>{item.reaction_total} ♥</span>}
                  </>
                )}
              </div>
            </button>
          ))}
        </Section>
      )}
    </>
  );
}
